export const DROPDOWN_WIDTH = 248;
export const DROPDOWN_HEIGHT = 224;

export const TOOLBAR_GROUP_OPTIONS = [
  { value: "premium", label: "Premium Support" },
  { value: "enterprise", label: "Enterprise" },
  { value: "standard", label: "Standard Support" },
  { value: "basic", label: "Basic" },
];

export const GROUP_FILTER_TO_ROW = {
  premium: "Group A",
  enterprise: "Group B",
  standard: "Group A",
  basic: "Group B",
};

export const BULK_ASSIGN_GROUPS = [
  { id: "bg1", name: "NSO Orientation", members: 8 },
  { id: "bg2", name: "Premium Support", members: 12 },
  { id: "bg3", name: "Enterprise", members: 24 },
  { id: "bg4", name: "Standard Support", members: 6 },
];

export const BULK_GROUP_TO_ROW = {
  bg1: "Group A",
  bg2: "Group A",
  bg3: "Group B",
  bg4: "Group B",
};

export function parseListParam(value) {
  if (!value) return [];
  return value.split(",").map((v) => v.trim()).filter(Boolean);
}
